<template>

    <h2>Záverečné práce</h2>
        <v-row align="center" style="margin:1px">
            <v-spacer />
                <v-btn size="small" variant="outlined" style="margin-right:1px" @click="toggle_select = 3">Zápis</v-btn>
                <v-btn size="small" variant="outlined" style="margin-right:1px" @click="toggle_select = 1">Hodnotenie</v-btn>
                <v-btn size="small" variant="outlined" style="margin-right:1px" @click="toggle_select = 0" v-if="user_type == 'student'">Výsledky</v-btn>
                <v-btn size="small" variant="outlined" style="margin-right:1px" @click="toggle_select = 2" v-if="user_type == 'teacher'" >Celkové výsledky</v-btn>
        </v-row>    

    <v-card-text>
     <ThesesEvaluation v-if="toggle_select == 1" />
     <ThesesResults v-if="toggle_select == 0 && user_type=='student'" />
     <AllThesesResults v-if="toggle_select == 2 && user_type=='teacher'" />
     <TermsSelection v-if="toggle_select == 3" />
     </v-card-text>
</template>

<script>
import axios from '../axios-auth.js'
import TermsSelection from './presentations/terms_selection.vue'
import ThesesEvaluation from './presentations/theses_evaluation.vue'
import ThesesResults from './presentations/theses_results.vue'
import AllThesesResults from './presentations/all_theses_results.vue'

export default {
    data() {
        return {
            user_type : '',
            toggle_select: 0
        }
    },
    components: {
        TermsSelection,
        ThesesEvaluation,
        ThesesResults,
        AllThesesResults
    },
    mounted() {
        this.initData()
    },
    methods : {
        initData() {
            this.$store.commit('setFeedback', null)
            this.getUserType()
        },
        getUserType() {
            axios.get('/get-presn-user-type', this.$store.getters.getAxiosConfig)
            .then(res => {
                this.user_type = res.data.result  
                // console.log(res.data)                  
                if (res.data.message != 'OK') {
                    this.$store.commit('setFeedback', res.data.message)
                } 
            })
            .catch(error => {
                this.$store.commit('setFeedback', error.name+': '+error.message)
            })
        },
    }
}
</script>

<style>

</style>